import { render, staticRenderFns } from "./StGptHubIntegration.vue?vue&type=template&id=a8af1312"
import script from "./StGptHubIntegration.vue?vue&type=script&lang=ts"
export * from "./StGptHubIntegration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports